// A primeira tela de quem entra com a senha que veio pronta.
//
// As seis contas nasceram com senha que outra pessoa gerou e mandou por
// mensagem. Até esta tela ser usada, cada conta abre o quadro clínico da Dona
// Maria para quem passar o olho naquela conversa. Senha que outra pessoa
// conhece não é senha, é um bilhete.
//
// Isto não é um convite: a API recusa qualquer outra coisa enquanto a troca não
// acontece. Esta tela é só o caminho amigável para o que já está bloqueado.
import { useState, type FormEvent } from 'react';
import { chamar } from '../api';

export function TrocarSenha({ nome, aoTrocar, aoSair }: {
  nome: string;
  aoTrocar: () => void;
  aoSair: () => void;
}) {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [senhaNova, setSenhaNova] = useState('');
  const [repetida, setRepetida] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const curta = senhaNova.length > 0 && senhaNova.length < 8;
  const diferem = repetida.length > 0 && senhaNova !== repetida;
  const podeSalvar = Boolean(senhaAtual) && senhaNova.length >= 8 && senhaNova === repetida && !salvando;

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    if (!podeSalvar) return;
    setErro('');
    setSalvando(true);
    try {
      await chamar('/sessao/senha', { metodo: 'POST', corpo: { senhaAtual, senhaNova } });
      aoTrocar();
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não consegui trocar a senha.');
    } finally {
      setSalvando(false);
    }
  }

  return (
    <main style={{ display: 'grid', placeItems: 'center', minHeight: '100%', padding: 'var(--gap-4)' }}>
      <form onSubmit={enviar} className="cartao" style={{ width: 'min(100%, 380px)', display: 'grid', gap: 'var(--gap-4)' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--serif)', fontSize: 25, fontWeight: 400 }}>
            Olá, {nome.split(' ')[0]}
          </h1>
          <p style={{ color: 'var(--texto-2)', fontSize: 14, lineHeight: 1.5, marginTop: 6 }}>
            Antes de entrar, escolha uma senha sua.
          </p>
          <p style={{ color: 'var(--texto-3)', fontSize: 12.5, lineHeight: 1.55, marginTop: 8 }}>
            A senha que você usou foi criada por outra pessoa e enviada por
            mensagem — então ela não é só sua. A que você escolher agora ninguém
            mais vê, nem eu.
          </p>
        </div>

        <div className="campo">
          <label htmlFor="atual">Senha que você recebeu</label>
          <input id="atual" type="password" autoComplete="current-password" required autoFocus
            value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)} />
        </div>

        <div className="campo">
          <label htmlFor="nova">Nova senha</label>
          <input id="nova" type="password" autoComplete="new-password" required
            value={senhaNova} onChange={(e) => setSenhaNova(e.target.value)} />
          <small style={{ fontSize: 12, color: curta ? 'var(--atencao)' : 'var(--texto-3)' }}>
            {curta
              ? `faltam ${8 - senhaNova.length} ${8 - senhaNova.length === 1 ? 'caractere' : 'caracteres'}`
              : 'pelo menos 8 caracteres — uma que você lembre sem anotar'}
          </small>
        </div>

        <div className="campo">
          <label htmlFor="repetir">Repita a nova senha</label>
          <input id="repetir" type="password" autoComplete="new-password" required
            value={repetida} onChange={(e) => setRepetida(e.target.value)} />
          {diferem && (
            <small style={{ fontSize: 12, color: 'var(--atencao)' }}>as duas não estão iguais</small>
          )}
        </div>

        {erro && <p className="aviso-erro">{erro}</p>}

        <button className="botao" type="submit" disabled={!podeSalvar}>
          {salvando ? 'Salvando…' : 'Salvar e entrar'}
        </button>

        <button type="button" onClick={aoSair}
          style={{
            background: 'none', border: 0, color: 'var(--texto-3)',
            fontSize: 12.5, cursor: 'pointer', padding: 0, justifySelf: 'center',
          }}>
          sair
        </button>
      </form>
    </main>
  );
}
